import { useContext, useState } from "react";
import { Alert, FlatList, Platform, Pressable, View } from "react-native";
import { Modal, StyleSheet, Text, TouchableOpacity } from "react-native";
import { TextInput } from "react-native-gesture-handler";
import { UserContext } from "../globalData/UserContext";
import { globalStyles } from "../styles/globalStyles";
import MakeNotification from "./functions/MakeNotification";

export default function RequestModal({
  modalOpen,
  setModalOpen,
  requests,
  addBorrowTransaction,
  changeBorrowStatus,
  deleteRequest,
  item,
  sendPushNotif,
  closeInfoModal,
  setRequests,
  refresh,
  community,
}) {
  const [switchAlert, setSwitchAlert] = useState(true);
  const [borrowTime, setBorrowTime] = useState("");
  const [userSelected, setUserSelected] = useState({});
  const userData = useContext(UserContext);

  function removeRequestsHandler() {
    changeBorrowStatus("available");
    deleteRequest();
    setRequests([]);
    closeInfoModal(false);
    setModalOpen(false);
    setSwitchAlert(true);
    refresh();
    Alert.alert(
      "requests deleted! Your book is available now. Refresh to see changes. "
    );
  }
  async function submitHandler() {
    if (
      !isNaN(borrowTime) &&
      parseInt(borrowTime) > 0 &&
      parseInt(borrowTime) < 1000
    ) {
      const futureDate = createFutureDate(borrowTime);
      await addBorrowTransaction(userSelected, futureDate);
      await changeBorrowStatus("borrowed", userSelected);
      await deleteRequest();
      if (userSelected.pushToken != null) {
        sendPushNotif(
          userSelected,
          "your request was approved!",
          item.title +
            " was approved to borrow. Check to see the borrowing information for this book"
        );
        MakeNotification(
          "request approved",
          userSelected,
          userData.user.data.getUsers,
          item.title +
            " was approved to borrow. Check to see the borrowing information for this book",
          community
        );
      }
      Alert.alert(
        userSelected.userName + " has borrowed your book: " + item.title
      );
      setModalOpen(false);
      closeInfoModal(false);
      refresh();
    } else {
      Alert.alert(
        "Please enter a valid borrow time.",
        "Request did not go through, please accept this request again with a valid borrow time",
        [{ text: "OK" }]
      );
      if (Platform.OS == "web")
        window.confirm(
          "Request did not go through, please accept this request again with a valid borrow time"
        );
    }

    function createFutureDate(time) {
      const daysDue = parseInt(time);
      const date = new Date();
      date.setDate(date.getDate() + daysDue);
      return date.toLocaleDateString();
    }
  }
  return (
    <Modal visible={modalOpen} transparent={true} animationType={"fade"}>
      <View style={styles.modalStyle}>
        {switchAlert ? (
          <View>
            <Text
              style={{
                ...globalStyles.titleText,
                fontSize: 25,
                marginBottom: 10,
                color: "black",
              }}
            >
              Select the borrower:
            </Text>
            <FlatList
              data={[
                ...requests,
                { userName: "delete requests" },
                { userName: "cancel" },
              ]}
              renderItem={({ item }) => (
                <TouchableOpacity
                  style={{
                    backgroundColor: "white",
                    width: 300,
                    alignItems: "center",
                    borderRadius: 20,
                    opacity: 0.7,
                    marginBottom: 8,
                  }}
                  onPress={() => {
                    setSwitchAlert(false);
                    if (item.userName == "delete requests")
                      removeRequestsHandler();
                    else if (item.userName == "cancel") {
                      closeInfoModal(false);
                      setModalOpen(false);
                    } else setUserSelected(item);
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "quicksand-bold",
                      fontSize: 20,
                      marginHorizontal: 7,
                      backgroundColor: "white",
                    }}
                  >
                    {item.userName}
                  </Text>
                </TouchableOpacity>
              )}
            />
          </View>
        ) : (
          <View>
            <Text
              style={{
                ...globalStyles.titleText,
                fontSize: 25,
                color: "black",
                marginTop: 20,
              }}
            >
              Choose the borrow time
            </Text>
            <TextInput
              style={styles.input}
              placeholderTextColor="#7191ad"
              placeholder="enter a number here"
              onChangeText={(text) => {
                setBorrowTime(text);
              }}
            />
            <Pressable
              style={{ alignItems: "center" }}
              onPress={async () => {
                await submitHandler();
              }}
            >
              <Text
                style={{
                  fontFamily: "quicksand-bold",
                  fontSize: 18,
                  marginBottom: 20,
                  color: "#5888e8",
                }}
              >
                SUBMIT
              </Text>
            </Pressable>
          </View>
        )}
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  input: {
    ...globalStyles.input,
    borderColor: "#7191ad",
    fontSize: 20,
    color: "black",
    marginBottom: 20,
    padding: 10,
  },
  modalStyle: {
    justifyContent: "center",
    alignItems: "center",
    marginTop: 200,
    marginBottom: 150,
    backgroundColor: "#a9d1de",
    opacity: 0.9,
    marginHorizontal: 30,
    borderRadius: 20,
  },
});
